import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { FormGroup } from "@/components/Form/Base/formGroup.component";
import { Input } from "@/components/Form/Base/input.component";
import { Label } from "@/components/Form/Base/label.component";
import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useDeliveryItemContext } from "../../context/deliveryItem.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { t } = useGranite();

    const {
        option,
        deliveryTypesDisabled,
        checked,
        onChangeDeliveryType,
        deliveryTooltipItem
    } = useDeliveryItemContext();

    return (
        <div className={cn(className)}>
            <FormGroup toggle={true}>
                <Label
                    data-test={`deliveryItem-${option.deliveryType}-label`}
                    className={cn("tw:m-0")}
                    htmlFor={option.deliveryType}
                >
                    <Input
                        data-test={`deliveryItem-${option.deliveryType}-input`}
                        type={"radio"}
                        id={option.deliveryType}
                        name={option.deliveryType}
                        value={option.deliveryType}
                        onClick={onChangeDeliveryType}
                        checked={checked && !deliveryTypesDisabled}
                        disabled={deliveryTypesDisabled}
                    />
                    {t(
                        `general.ecommerce.radio.deliveryType.${option.deliveryType}`
                    )}
                    {deliveryTooltipItem && (
                        <Tooltip
                            data-test={`deliveryItem-${option.deliveryType}-tooltip`}
                            title={deliveryTooltipItem.title}
                            innerHTML={deliveryTooltipItem.text}
                        />
                    )}
                </Label>
            </FormGroup>
            {children}
        </div>
    );
};
